import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { encryptText } from "../helper/encryptHelper";
import io from "socket.io-client";
import { getCredit } from "./creditReducer";

export const lotteryInvoiceReducer = createSlice({
  name: "lotteryInvoice",
  initialState: {
    memberSetting: null,
    totalbetcache: null,
    holdNumber: null,
    resultBuy: null,
    invoiceMember: null,
    numset: null,
    historyHuay: [],
    ticket: [],
    statusHolding: false,
    lastTimer: 900 * 100000000,
    detailLotteryRoundDate: null
  },
  reducers: {
    setMemberSetting: (state, { payload }) => {
      state.memberSetting = payload;
    },
    setTotalBetCache: (state, { payload }) => {
      state.totalbetcache = payload;
    },
    setHoldNumber: (state, { payload }) => {
      state.holdNumber = payload;
    },
    setResultBuy: (state, { payload }) => {
      state.resultBuy = payload;
    },
    setInvoiceMember: (state, { payload }) => {
      state.invoiceMember = payload;
    },
    setNumSet: (state, { payload }) => {
      state.numset = payload;
    },
    setHistoryHuay: (state, { payload }) => {
      state.historyhuay = payload
    },
    setTicket: (state, { payload }) => {
      state.ticket = payload
    },
    setStatusHoldSuccess: (state, { payload }) => {
      state.statusHolding = payload
    },
    setLastTimer: (state, { payload }) => {
      state.lastTimer = payload
    },
    setDetailLotteryRoundDate: (state, { payload }) => {
      state.detailLotteryRoundDate = payload
    }
  },
});

export const {
  setAllLottery,
  setMemberSetting,
  setTotalBetCache,
  setHoldNumber,
  setResultBuy,
  setInvoiceMember,
  setNumSet,
  setHistoryHuay,
  setTicket,
  setLastTimer,
  setDetailLotteryRoundDate
} = lotteryInvoiceReducer.actions;
export default lotteryInvoiceReducer.reducer;

const header2 = {
  headers: {
    "Content-Type": "application/text/plain",
    Authorization: `Bearer ${localStorage.getItem("Token")}`,
  },
};

let socketHuay;

const getInvoiceMember = (body) => async (dispatch) => {
  // console.log('come')
  body.query.member = localStorage.getItem("member");

  const cryptoData = encryptText(
    JSON.stringify(body),
    localStorage.getItem("Key")
  );

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryInvoice/cusSite/getLotteryInvoicesMember`,
      cryptoData,
      header2
    );
    // console.log(res)
    if (res.data.code == "999999") {
      dispatch(setInvoiceMember(res.data));
    }
  } catch (err) {
    console.error(err);
  }
};

const getNumberSet = () => async (dispatch) => {
  const body = { member: localStorage.getItem("member") };
  const cryptoData = encryptText(
    JSON.stringify(body),
    localStorage.getItem("Key")
  );

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_BET_NUMSET}/api/betNumberSet/cusSite/getBetNumberSets`,
      cryptoData,
      header2
    );
    // console.log(res)
    if (res.data.code == "999999") {
      dispatch(setNumSet(res.data.data));
    }
  } catch (err) {
    console.error(err);
  }
};
const addTicketList = (body) => async (dispatch) => {
  // console.log(body)
  const cryptoData = encryptText(JSON.stringify(body), localStorage.getItem('Key'))

  try {
    const res = await axios.post(`${process.env.REACT_APP_API_BET_NUMSET}/api/betNumberSet/cusSite/newSet`, cryptoData, header2)
    // console.log(res)
    if (res.data.code == '999999') {
      alert('สร้างเลขชุดสำเร็จ')
    } else {
      // checkExpToken(res.data.code)
      // logout(res.data.code)
      alert('สร้างเลขชุดล้มเหลว กรุณาสร้างใหม่')
    }
    return res
  } catch (err) {
    console.error(err)
    // Sentry.captureException("addTicketList API",err);
  }
}
const deleteTicketList = (body) => async (dispatch) => {
  const cryptoData = encryptText(JSON.stringify(body), localStorage.getItem('Key'))

  try {
    const res = await axios.post(`${process.env.REACT_APP_API_BET_NUMSET}/api/betNumberSet/cusSite/removeSetById`, cryptoData, header2)
    if (res.data.code == '999999') {
      alert('ลบเลขชุดสำเร็จ')
      // console.log(res)
    } else {
      // checkExpToken(res.data.code)
      // logout(res.data.code)
      alert('ลบเลขชุดล้มเหลว')
    }
  } catch (err) {
    console.error(err)

  }
}
const getTotalbetCache = () => async (dispatch) => {
  const body = encryptText(
    JSON.stringify({
      lottery: localStorage.getItem("lotteryId"),
    }),
    localStorage.getItem("Key")
  );
  const body2 = encryptText(
    JSON.stringify({
      keyList: JSON.parse(
        localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
      ),
    }),
    localStorage.getItem("Key")
  );

  const body3 = encryptText(
    JSON.stringify({
      round_id: localStorage.getItem("roundId"),
    }),
    localStorage.getItem("Key")
  );

  try {
    const [res, res2, res3] = await Promise.all([
      axios.post(
        `${process.env.REACT_APP_API_LOTTERY}/api/memberSetting/cusSite/getMemberSettings`,
        body,
        header2
      ),
      axios.post(
        `${process.env.REACT_APP_API_LOTTERYROUND}/api/lotteryRoundSummary/cusSite/getTotalBetCacheData_keyList_front`,
        body2,
        header2
      ),
      axios.post(
        `${process.env.REACT_APP_API_LOTTERYROUND}/api/lotteryRound/cusSite/getTotalBetCacheFromHoldNumbers`,
        body3,
        header2
      ),
    ]);

    if (res.data.code == "999999") {
      dispatch(setMemberSetting(res.data));
    }

    if (res2.data) {
      dispatch(setTotalBetCache(res2.data));
    }

    if (res.data.code == "999999") {
      let tickets = JSON.parse(
        localStorage.getItem(localStorage.getItem("lotteryId"))
      );
      let ticketsWithRewardRate = [];
      let holdNumbers = [];

      tickets.map((ticket) => {
        const setting = res.data.data.find(
          (data) => ticket.lotteryType == data.betType
        ).baseStepPrices;

        console.log("setting", setting)
        const checkHold = res3.data.data.find(
          (data) =>
            ticket.lotteryType == data.betType &&
            ticket.lotteryNumber == data.betNumber
        );

        if (checkHold) {
          holdNumbers.push(checkHold);
          if (checkHold.betLimit - checkHold.totalBet > 0) {
            ticket.rewardRate = checkHold.price;
            ticket.rewardAmount = checkHold.price;
          } else {
            ticket.rewardRate = 0;
            ticket.rewardAmount = 0;
          }
        } else {
          let Number = "";
          if (ticket.lotteryType == "tode_3") {
            Number = ticket.lotteryNumber.split("").sort().join("");
          } else {
            Number = ticket.lotteryNumber;
            console.log(Number)
          }
          // console.log(res2.data.data[ticket.lotteryType][Number])
          // console.log(res2.data)
          const cache = res2.data[ticket.lotteryType][Number];
          console.log("cache", cache)
          const rewarRate = setting.find(
            (data) => cache[data.price] < data.betLimit
          );
          console.log("rewarRate", rewarRate)
          if (rewarRate == undefined) {
            ticket.rewardRate = 0;
            ticket.rewardAmount = 0;
          } else {
            ticket.rewardRate = rewarRate.price;
            ticket.rewardAmount = rewarRate.price;
          }

          // console.log(ticket)
        }
        ticketsWithRewardRate.push(ticket);
      });

      // console.log('test',holdNumbers)
      dispatch(setHoldNumber(holdNumbers));

      localStorage.setItem(
        localStorage.getItem("lotteryId"),
        JSON.stringify(ticketsWithRewardRate)
      );
    }
  } catch (err) {
    console.error(err);
  }
};

const getTotalbetCacheJackpot = () => async (dispatch) => {

  const keyList = JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId"))).map(data => {
    return ({
      lotteryRound: data.lotteryRound,
      betNumber: data.lotteryNumber
    })
  })

  const body = encryptText(
    JSON.stringify({
      lottery: localStorage.getItem("lotteryId"),
    }),
    localStorage.getItem("Key")
  );
  const body2 = encryptText(
    JSON.stringify({
      keyList: keyList,
    }),
    localStorage.getItem("Key")
  );

  try {
    const [res, res2] = await Promise.all([
      axios.post(
        `${process.env.REACT_APP_API_LOTTERY}/api/memberSetting/cusSite/getMemberSettings`,
        body,
        header2
      ),
      axios.post(
        `${process.env.REACT_APP_API_LOTTERYROUND}/api/lotteryRoundSummary/cusSite/getTotalBetCacheData_jackpot6d`,
        body2,
        header2
      )
    ]);
    console.log("res.data :", res.data.data[0].maximumBetPerTicket)
    console.log("res2.data :", res2.data)

    if (res.data.code == "999999") {
      dispatch(setMemberSetting(res.data?.data[0]?.maximumBetPerTicket));
    }

    if (res2.data) {
      dispatch(setTotalBetCache(res2.data));
    }

  } catch (err) {
    console.error(err);
  }
}

const newLotteryInvoice = async (tickets, totalamount, invoiceRemark) => {
  const body = encryptText(
    JSON.stringify({
      member: localStorage.getItem("member"),
      lotteryRound: localStorage.getItem("roundId"),
      invoiceDatetime: new Date(),
      totalBetAmount: totalamount,
      currency: "credit",
      superMember:localStorage.getItem("superMember"),
      lottery_id: localStorage.getItem("lotteryId"),
      ticketList: tickets,
      remark: invoiceRemark,
    }),
    localStorage.getItem("Key")
  );

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryInvoice/cusSite/newLotteryInvoice`,
      body,
      header2
    );
    return res.data;
  } catch (err) {
    console.error(err);
  }
};
const getHistoryHuay = (body) => async dispatch => {
  const member = localStorage.getItem('member')
  body.memberId = "FX88880000"
  const cryptoData = encryptText(JSON.stringify(body), localStorage.getItem('Key'))
  const header2 = {
    headers: {
      'Content-Type': 'application/text/plain',
      'Authorization': `Bearer ${localStorage.getItem('Token')}`
    }
  }
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryInvoice/cusSite/getLotteryInvoicesMemberByMemberId`, cryptoData, header2)
    // console.log(res)
    if (res.data.code == '999999') {
      dispatch(setHistoryHuay(res.data.data))
      return res.data.data
    }

  } catch (err) {
    console.error(err)

  }
}

const getTickets = (body) => async dispatch => {

  const cryptoData = encryptText(JSON.stringify(body), localStorage.getItem('Key'))
  const header2 = {
    headers: {
      'Content-Type': 'application/text/plain',
      'Authorization': `Bearer ${localStorage.getItem('Token')}`
    }
  }
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryInvoice/cusSite/getLotteryInvoiceWithTicketByInvoiceId`, cryptoData, header2)
    // console.log(res)
    if (res.data.code == '999999') {
      dispatch(setTicket(res.data.data))
      return res.data.data
    }

  } catch (err) {
    console.error(err)

  }
}
const cancelInvoice = (data) => async dispatch => {
  // console.log("datassss",data)

  let cryptoData = encryptText(JSON.stringify({ member: "6006e03bef563f40b357b5a5", lotteryRound: data.lotteryRound }), localStorage.getItem('Key'))
  const header2 = {
    headers: {
      'Content-Type': 'application/text/plain',
      'Authorization': `Bearer ${localStorage.getItem('Token')}`
    }
  }
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryInvoice/cusSite/checkCancelInvoiceQuotas`, cryptoData, header2)
    // console.log(res)
    if (res.data.data > 0) {
      // alert(2)
      let body2 = encryptText(JSON.stringify({ id: data.invoiceId, lottery_id: data.lotteryId, operator: "6006e03bef563f40b357b5a5" }), localStorage.getItem('Key'))
      // console.log(body2)
      // alert(0)
      const res2 = await axios.post(`${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryInvoice/cusSite/cancelInvoice`, body2, header2)
      // console.log("res2",res2)
      if (res2.data.code == '999999') {
        alert(`คืนโพยสำเร็จ ท่านสามารถคืนโพยหวยรอบนี้ได้อีก ${res.data.data - 1} ครั้ง`)
        return res2.data.code
      }

    } else {
      alert('โควต้าในการคืนโพยของรอบนี้หมดแล้ว')
    }

  } catch (err) {
    // console.log("fuck",err)
    console.error(err)

  }
}

const SocketResultHuay = () => {
  socketHuay = io(process.env.REACT_APP_API_SOCKET_LOTTERY, {
    auth: {
      token: `Bearer ${localStorage.getItem("Token")}`,
    },
  });
  if (socketHuay) {
    // console.log("come to huayyak", socketHuay);
    socketHuay.on("connect_error", (err) => {
      console.log(`connect_error due to ${err.message}`);
    });
  }
};

const getResultBuyHuay = () => async (dispatch) => {
  socketHuay?.on("newInvoiceResult", (msg) => {
    // console.log("socket detected!!!");
    // console.log(msg);
    dispatch(setResultBuy(msg));
    dispatch(getCredit())
  });
};

const resetResultHuay = () => async (dispatch) => {
  dispatch(setResultBuy(null));
};

const disconnectHuayYak = () => {
  // console.log('test')
  if (socketHuay) {
    socketHuay.disconnect();
  }
};

const addLotteryHoldNumber = () => async (dispatch) => {
  try {
    const listNumber = JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId"))).map(data => {
      return data.lotteryNumber
    })
    // console.log("listNumber :", listNumber)
    const body = encryptText(
      JSON.stringify({
        lotteryRound: localStorage.getItem("roundId"),
        ticketList: listNumber
      }),
      localStorage.getItem("Key")
    );
    const res = await axios.post(
      `${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryTicket/cusSite/addJackpotTicketsAsHolding`,
      body,
      header2
    )
    // console.log("res :", res.data)
    if (!(res.data.code == "999999" && res.data.message == "SUCCESS")) {
      return false
    }
    return true
  } catch (error) {
    console.error(error);
    return false
  }
}

const getDetailLotteryHoldNumber = () => async (dispatch) => {
  try {
    // console.log("getDetailLotteryHoldNumber")
    const body = encryptText(
      JSON.stringify({
        lotteryRound: localStorage.getItem("roundId")
      }),
      localStorage.getItem("Key")
    );
    const res = await axios.post(`${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryTicket/cusSite/getJackpot6dShopCart`, body, header2);
    // console.log(res.data)
    await dispatch(setLastTimer(res.data.data.ttl * 1000))
    return res.data.data.ttl * 1000
  } catch (error) {
    console.error(error);
    return false
  }
}

const removeLotteryHoldNumber = (listNumber) => async (dispatch) => {
  try {

    // console.log("listNumber :", listNumber)
    const body = encryptText(
      JSON.stringify({
        lotteryRound: localStorage.getItem("roundId"),
        ticketList: listNumber
      }),
      localStorage.getItem("Key")
    );
    const res = await axios.post(
      `${process.env.REACT_APP_API_LOTTERYINVOICE}/api/lotteryTicket/cusSite/removeJackpotTicketsAsHolding`,
      body,
      header2
    )
    console.log("removeLotteryHoldNumber res :", res.data)
    if (!(res.data.code == "999999" && res.data.message == "SUCCESS")) {
      return false
    }
    return true
  } catch (error) {
    console.error(error);
    return false
  }
}

const getDetailLotteryRound = () => async (dispatch) => {
  try {
    const body = encryptText(
      JSON.stringify({
        id: localStorage.getItem("roundId"),
      }),
      localStorage.getItem("Key")
    );

    const res = await axios.post(
      `${process.env.REACT_APP_API_LOTTERYROUND}/api/lotteryRound/cusSite/getLotteryRoundById`,
      body,
      header2
    )

    console.log("resasdasd :", res.data.data.roundDate)
    if (res.data.code == "999999") {
      await dispatch(setDetailLotteryRoundDate(res.data.data.roundDate))
    }
  } catch (error) {
    console.error(error)
  }
}

export {
  getInvoiceMember,
  getNumberSet,
  addTicketList,
  deleteTicketList,
  getTotalbetCache,
  newLotteryInvoice,
  SocketResultHuay,
  getResultBuyHuay,
  resetResultHuay,
  disconnectHuayYak,
  getHistoryHuay,
  cancelInvoice,
  getTickets,
  addLotteryHoldNumber,
  removeLotteryHoldNumber,
  getDetailLotteryHoldNumber,
  getTotalbetCacheJackpot,
  getDetailLotteryRound
};